import { useQuery } from '@tanstack/react-query';
import { emailSchedulerControllerListSchedulesOptions } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import type { ScheduledEmailStatus } from '@dealstack/shared/lib/backendClient';

export const useScheduledEmails = ({
	dealId,
	programmeId,
	status,
	documentWorkflowInstanceId,
}: {
	dealId: string;
	programmeId: string;
	status?: ScheduledEmailStatus;
	documentWorkflowInstanceId?: string;
}) => {
	return useQuery({
		...emailSchedulerControllerListSchedulesOptions({
			path: { dealId, programmeId },
			query:
				status || documentWorkflowInstanceId
					? {
							...(status ? { status } : {}),
							...(documentWorkflowInstanceId ? { documentWorkflowInstanceId } : {}),
						}
					: undefined,
		}),
	});
};
